module.exports = __webpack_public_path__ + "static/hrdag-d44e6016287ccd31e21aa0770ef63628.png";